/**
 * Work Orders Reducer
 * Initial state and action handler for work orders list
 */

const initialState = { data: [], loading: true };

export const GetAllWorkOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_all_work_orders":
      return {
        data: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

// Initial work order data structure (for form default values)
export const workOrderDataState = {
  WorkOrderId: 0,
  WorkOrderNumber: null,
  ContractorId: null,
  ProjectId: null,
  Description: null,
  Cost: null,
  StartDate: null,
  EndDate: null,
  Status: "Pending",
};
